import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=5841304a&scoped=true&"
import script from "./CustomButton.vue?vue&type=script&lang=js&"
export * from "./CustomButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=5841304a&prod&scoped=true&lang=css&"
import style1 from "./CustomButton.vue?vue&type=style&index=1&id=5841304a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841304a",
  null
  
)

export default component.exports